import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-zoom-icon',
  templateUrl: 'chart-zoom-icon.component.html'
})
export class ChartZoomIconComponent {
  constructor() {}
}
